import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOPS_M1_RecursiveDescentParsing = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Recursive Descent Parsing"
    videos={[
      "https://www.youtube.com/embed/odoHgcoombw",
    ]}
    takeaways={[
      { text: "This is the simplest parser among all the parsers" },
      { text: "We can expect question from this topic in CAT1" },
    ]}
    questions={[
      "Write the Recursive Procedure Top-Down parsing for the following CFG. Check whether the string w=acadb is parsed by the above CFG. S->AB; A -> aA| bB | Ac | Ab; B->b |aB",
      "Construct a recursive descent parser for the grammar S-> '(' S ')' | ')'. Will it parse correctly?",
      "Create a Recursive Descent parser for the following context-free grammar. E->num T; T->*num T| ɛ",
    ]}
    exampleVideos={[]}
  />
);
}

export default OOPS_M1_RecursiveDescentParsing;
